module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section invisalign-testimonials"
  }, [_c('div', {
    staticClass: "section__container invisalign-testimonials__container"
  }, [_c('div', {
    staticClass: "section__header invisalign-testimonials__header"
  }, [_c('div', {
    staticClass: "section__header-title invisalign-testimonials__header-title"
  }, [_vm._v(_vm._s(_vm.content.testimonials.title))])]), _c('div', {
    staticClass: "invisalign-testimonials__slider"
  }, [_c('SliderText', {
    attrs: {
      "content": _vm.content.testimonials
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43ca0862"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-invisalign-testimonials/custom-invisalign-testimonials.pug
// module id = 514
// module chunks = 1